module.exports = __webpack_public_path__ + "img/06.0384ebe9.png";